import { FundingSource, TopupScope } from '../services/merchant-funding.service';

export const TOPUP_SCOPE_LABELS: Record<TopupScope, string> = {
  WALLET_ONLY: 'Wallet only (bank wire)',
  INTEGRATION_ONLY: 'Integration float only',
  WALLET_AND_INTEGRATION: 'Operator deposit (wallet + integration)',
};

export const TOPUP_SCOPE_HINTS: Record<TopupScope, string> = {
  WALLET_ONLY: 'Debit BANK_TRANSFER market · Credit LIABILITY_WALLET',
  INTEGRATION_ONLY: 'Debit ASSET_ENTITY_BALANCE · Credit BANK_TRANSFER market',
  WALLET_AND_INTEGRATION: 'Debit ASSET_ENTITY_BALANCE · Credit LIABILITY_WALLET',
};

export const FUNDING_SOURCE_LABELS: Record<FundingSource, string> = {
  OPERATOR_DIRECT: 'Operator direct deposit',
  BANK_WIRE: 'Bank wire',
  INTERNAL_TRANSFER: 'Internal transfer',
};

export function topupScopeLabel(scope: TopupScope): string {
  return TOPUP_SCOPE_LABELS[scope] ?? scope;
}

export function topupScopeHint(scope: TopupScope): string {
  return TOPUP_SCOPE_HINTS[scope] ?? '';
}

export function fundingSourceLabel(source: FundingSource): string {
  return FUNDING_SOURCE_LABELS[source] ?? source;
}

export function scopesForMode(mode: 'fund-merchant' | 'wallet-fund' | 'integration-topup'): TopupScope[] {
  if (mode === 'integration-topup') {
    return ['INTEGRATION_ONLY'];
  }
  return ['WALLET_ONLY', 'INTEGRATION_ONLY', 'WALLET_AND_INTEGRATION'];
}

export function scopeNeedsWallet(scope: TopupScope): boolean {
  return scope === 'WALLET_ONLY' || scope === 'WALLET_AND_INTEGRATION';
}
